export default __webpack_public_path__ + "static/media/Health-Support-Header-Banner-mobile-640x300.067a6f50.jpg";